import { Modal, UI, Utils } from 'common';
import React, { useContext } from 'react';
import GBBPlanChangeModal from './GBBPlanChangeModal.component.js';

const { ModalContext } = Modal;
const { Analytics, BillingPlans } = Utils;
const { WrappedButton } = UI;
const { prettyPrintPlan } = BillingPlans;

export const GBBPlanTile = ({
	mobileCls,
	isCurrentPlan,
	planName,
	summary,
	price,
	currentPlanPrice,
	currentPlanName,
	isPlanInProgress,
	onGBBChangePlan,
	currentPlanSku,
	pendingPlanId,
	sku,
	parseDescription,
}) => {
	const { showModal } = useContext(ModalContext);

	const onPlanChange = () => {
		const planSelectionProperties = {
			prior_plan_selected: currentPlanName,
			prior_monthly_plan_cost: currentPlanPrice,
			new_plan_selected: planName,
			new_monthly_plan_cost: price,
		};

		Analytics.trackEvent(
			'planSelectionInteracted',
			planSelectionProperties,
			Analytics.agent.segment
		);

		showModal({
			component: GBBPlanChangeModal,
			data: {
				newPlanPrice: price,
				newPlanName: planName,
				onGBBChangePlan,
				currentPlanSku,
				sku,
				currentPlanPrice,
			},
		});
	};

	const selected =
		(pendingPlanId !== null && isPlanInProgress) ||
		(pendingPlanId === null && isCurrentPlan)
			? ' selected'
			: '';
	const showSelectButton = !isCurrentPlan && !isPlanInProgress;
	const splitText = summary.split('  -').filter(text => text !== '');

	const planTag = splitText.shift();
	const planSubHeader = splitText.shift();

	return (
		<div className={`gbb-account-plan-tile${selected}${mobileCls}`}>
			{((pendingPlanId !== null && isPlanInProgress) ||
				(pendingPlanId === null && isCurrentPlan)) && (
				<p className="current-plan-title">Current Plan</p>
			)}

			<div className="plan-info">
				<div className="plan-details">
					<div>
						<p className="plan-name">{prettyPrintPlan(planName)}</p>
						<p className="plan-name-tag">{planTag}</p>
					</div>
					<div className="plan-cost">
						{`$${price}`}
						<span className="plan-mo">/mo</span>
					</div>
				</div>

				<div className="plan-content">
					<p className="plan-sub-header">{planSubHeader}</p>
					<div className="plan-list">
						<div>{parseDescription(splitText)}</div>
					</div>
				</div>

				{showSelectButton && (
					<WrappedButton
						label="Select Plan"
						className="gbb-button select-plan"
						onClick={onPlanChange}
						dataqa="select-gbb-plan"
						buttonType="secondary"
					/>
				)}
			</div>
		</div>
	);
};
